import React from "react"

import { Switch } from "@coval/ui"

import { LABEL_ROW_STYLES } from "../styles"

interface ThinkingConfigProps {
  enabled: boolean
  onChange: (enabled: boolean) => void
}

export const ThinkingConfig: React.FC<ThinkingConfigProps> = ({
  enabled,
  onChange,
}) => {
  return (
    <div className="mt-3 rounded-lg border border-coval-border bg-content1 px-3 py-2">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className={LABEL_ROW_STYLES}>
            <p className="text-sm font-medium text-foreground">Thinking Mode</p>
          </div>
          <p className="text-xs text-coval-text-muted">
            Enable extended reasoning before the evaluation response.
          </p>
        </div>
        <Switch
          checked={enabled}
          onCheckedChange={onChange}
          aria-label="Enable thinking mode"
        />
      </div>
    </div>
  )
}
